import userHttp from '@/api/userHttp';
import CustomError from './CustomError';
import guestHttp from '@/api/guestHttp';

function createRequest(type, method) {
    return async function <T>(
        url: string,
        defaultValue: T,
        errorPath: string = '',
        data = {}
    ): Promise<[CustomError | null, T]> {
        try {
            const { success, error, result, response } = await type[method](url, data);
            //            console.log(success, error, result);
            const customError = success ? null : new CustomError(error, errorPath);
            const resultData = success ? result : response.data;
            return [customError, resultData];
        } catch (error) {
            const customError = new CustomError(error, errorPath);
            return [customError, defaultValue];
        }
    };
}

export default {
    user: {
        get: createRequest(userHttp, 'get'),
        post: createRequest(userHttp, 'post'),
        put: createRequest(userHttp, 'put'),
        delete: createRequest(userHttp, 'delete'),
    },
    guest: {
        get: createRequest(guestHttp, 'get'),
        post: createRequest(guestHttp, 'post'),
    },
};
